import Link from 'next/link';
import React from 'react';
import { forwarderConfig } from '../../globals/ForwarderConfig';
import { LoginButton } from '../LoginButton';
import {
    PageHeader_Left,
    PageHeader_Right,
    PageHeader_Root,
    PageHeader_SearchBar
} from './PageHeader.style';

/**
 * @typedef PageHeaderProps
 * @property {function} searchCallback The function to be called for looking up tracking information.
 * @property {function} loginCallback The function to be called for login.
 * @property {boolean} [hideSearchBar] Conditionally renders the search bar
 */

/** @type {React.FC<PageHeaderProps>} */
export const PageHeader = ({
    searchCallback,
    hideSearchBar,
    loginCallback
}) => {
    return (
        <PageHeader_Root>
            <PageHeader_Left
                forwarder={process.env.FORWARDER}
            >
                <Link
                    href='/'
                    id='forwarderButton'
                    title={`Go to ${process.env.FORWARDER} Tracking Home Page`}
                >
                    <img
                        alt={process.env.FORWARDER}
                        src={forwarderConfig[process.env.FORWARDER].logoSrc}
                    />
                </Link>
            </PageHeader_Left>
            <PageHeader_Right>
                {hideSearchBar || (<PageHeader_SearchBar searchCallback={searchCallback} />)}
                <LoginButton
                    id='loginButton'
                    onClick={
                        (/** @type {React.MouseEventHandler<HTMLButtonElement>} */(loginCallback))
                    }
                />
            </PageHeader_Right>
        </PageHeader_Root>
    );
};
